// hooks/useNavigationWarning.ts
import { useEffect, useCallback } from 'react';

interface UseNavigationWarningProps {
  hasUnsavedChanges: boolean;
  message?: string;
}

export const useNavigationWarning = ({
  hasUnsavedChanges,
  message = "You have unsaved changes. All your data will be cleared if you leave this page. Are you sure you want to leave?"
}: UseNavigationWarningProps) => {
  
  // Handle browser/tab close, refresh, or back/forward navigation
  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (hasUnsavedChanges) {
        e.preventDefault();
        e.returnValue = message;
        return message;
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [hasUnsavedChanges, message]);

  // Handle browser back button
  useEffect(() => {
    const handlePopState = (e: PopStateEvent) => {
      if (hasUnsavedChanges) {
        const confirmLeave = window.confirm(message);
        if (!confirmLeave) {
          // Push state back to prevent navigation
          window.history.pushState(null, '', window.location.href);
        }
      }
    };

    // Push initial state
    window.history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [hasUnsavedChanges, message]);
};